import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.css',
    standalone: false
})
export class BreadcrumbComponent {
  @Input() Pagina = '';
  @Input() Titulo = '';
  @Input() PaginaPai = '';
  @Input() LinkPaginaPai = '';
  @Input() TemPaginaPai = false;
}
